// import FeedIndex from "./pages/Feed/Index";
import UserSignup from "@/pages/User/Signup";
import Policy from "@/pages/common/Policy";
import Law from "@/pages/common/Law";

type routeType = {
  path: string;
  component: (React.FC) | (() => JSX.Element);
  login_required?: boolean;
  title?: string;
};

export const routes: routeType[] = [
  {
    path: "/",
    component: UserSignup,
    title: 'Home',
  },
  {
    path: "/policy",
    component: Policy,
    title: 'Policy',
  },
  {
    path: "/law",
    component: Law,
    title: 'Law',
  },
];
